import type { RouteRecordRaw } from "vue-router";
import { APP_SETTINGS_PAYMENTS_ROUTES } from "@/Generated/Routes/paths";

const invoices: RouteRecordRaw[] = [
  {
    ...APP_SETTINGS_PAYMENTS_ROUTES.root,
    meta: {
      noHeader: true,
    },
    component: () => import("@/Views/settings/payment-receipts/index.vue"),
  },
  {
    ...APP_SETTINGS_PAYMENTS_ROUTES.detail.root,
    meta: {
      noHeader: true,
    },
    component: () => import("@/Views/settings/payment-receipts/MonthDetail.vue"),
  },
];

export default invoices;
